import { render, staticRenderFns } from "./productDeleteDialog.vue?vue&type=template&id=14b5778a&scoped=true"
import script from "./productDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./productDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./productDeleteDialog.vue?vue&type=style&index=0&id=14b5778a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b5778a",
  null
  
)

export default component.exports